var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOnlineState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 37",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.934 32.438c-6.258-.73-12.683-4.582-17.115-10.912C1.349 15.142-.052 7.71 1.459 1.552c0 0 15.074 5.21 25.966 4.743 5.323-.232 23.997 5.134 21.383 30.285 0 0-.993-.091-2.632-.362-5.947-.99-20.059-3.405-23.242-3.78",
    fillRule: "evenodd"
  })));
}

export default SvgOnlineState;